<template>
  <section class="section container pt-0">
    <staff-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import StaffDatatable from "./staff_datatable/Index.vue";
export default {
  name: "StaffMember",
  components: {
    StaffDatatable,
  },
  data() {
    return {
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {},
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {
    this.retrieve_settings();
  },
};
</script>

<style scoped></style>
